export default "__VITE_ASSET__B31ZHUCM__"